// A message sent with files starts with an `@uploads/…` mention per file (see
// `mention` in lib/files). The chat shows those as small squares above the
// message rather than as raw paths inside it.

const LEADING = /^\s*@(?:"(uploads\/[^"]+)"|(uploads\/\S+))\s*/

export function splitUploads(text: string): { files: string[]; rest: string } {
  const files: string[] = []
  let rest = text
  for (let m = LEADING.exec(rest); m; m = LEADING.exec(rest)) {
    files.push((m[1] ?? m[2])!)
    rest = rest.slice(m[0].length)
  }
  return { files, rest: rest.trim() }
}
